import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { useSubscription } from '../context/SubscriptionContext';

const Support = () => {
  const { submitSupportTicket } = useSubscription();
  const [ticket, setTicket] = useState({ subject: '', message: '', priority: 'Normal' });
  const [submitted, setSubmitted] = useState(false);
  const [refId, setRefId] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const id = submitSupportTicket(ticket.subject, ticket.message, ticket.priority);
    setRefId(id);
    setSubmitted(true);
    setTicket({ subject: '', message: '', priority: 'Normal' });
  };

  if (submitted) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-8 text-center bg-slate-50">
        <div className="w-24 h-24 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
          <SafeIcon icon="✅" className="text-4xl text-emerald-600" />
        </div>
        <h2 className="text-2xl font-black text-slate-900">Takk for din henvendelse!</h2>
        <p className="text-slate-500 mt-2 font-medium">
          Saksnummer: <span className="font-mono text-slate-900">{refId}</span><br/>
          Vi har mottatt saken i vårt system og svarer fortløpende.
        </p>
        <button onClick={() => setSubmitted(false)} className="mt-8 px-6 py-3 bg-slate-900 text-white rounded-xl font-bold">Send ny henvendelse</button>
      </div>
    );
  }

  return (
    <div className="p-8 max-w-3xl mx-auto min-h-screen bg-slate-50">
      <h1 className="text-3xl font-black text-slate-900 mb-2">Kundesupport</h1>
      <p className="text-slate-500 font-medium mb-8">Vi er her for å hjelpe deg. Fyll ut skjemaet under.</p>

      <div className="bg-white p-8 rounded-[2rem] shadow-sm border border-slate-200">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2">Hva gjelder det?</label>
            <input required value={ticket.subject} onChange={e => setTicket({...ticket, subject: e.target.value})} className="w-full p-4 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-primary-500" placeholder="Kort beskrivelse..." />
          </div>
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2">Prioritet</label>
            <select value={ticket.priority} onChange={e => setTicket({...ticket, priority: e.target.value})} className="w-full p-4 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-primary-500 bg-white">
              <option>Lav</option>
              <option>Normal</option>
              <option>Høy</option>
              <option>Kritisk (System nede)</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2">Beskrivelse</label>
            <textarea required rows={5} value={ticket.message} onChange={e => setTicket({...ticket, message: e.target.value})} className="w-full p-4 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-primary-500" placeholder="Fortell oss detaljert om problemet..." />
          </div>
          <button type="submit" className="w-full py-4 bg-primary-600 text-white rounded-xl font-black text-lg hover:bg-primary-700 transition-all shadow-lg shadow-primary-200">
            Send Henvendelse
          </button>
        </form>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="p-6 bg-white rounded-2xl border border-slate-200 text-center">
          <SafeIcon icon="📞" className="text-3xl text-blue-500 mb-4 block mx-auto" />
          <h3 className="font-bold">Ring Oss</h3>
          <p className="text-sm text-slate-500 mt-1">+47 900 00 000</p>
          <p className="text-xs text-slate-400 mt-1">Man-Fre 08-16</p>
        </div>
        <div className="p-6 bg-white rounded-2xl border border-slate-200 text-center">
          <SafeIcon icon="📧" className="text-3xl text-purple-500 mb-4 block mx-auto" />
          <h3 className="font-bold">E-post</h3>
          <p className="text-sm text-slate-500 mt-1">support@saleswork.no</p>
          <p className="text-xs text-slate-400 mt-1">Svartid &lt; 24t</p>
        </div>
        <div className="p-6 bg-white rounded-2xl border border-slate-200 text-center">
          <SafeIcon icon="📚" className="text-3xl text-emerald-500 mb-4 block mx-auto" />
          <h3 className="font-bold">Kunnskapsbase</h3>
          <p className="text-sm text-slate-500 mt-1">Finn svar selv</p>
          <a href="/#/knowledge-base" className="text-xs text-primary-600 font-bold mt-1 hover:underline">Gå til guider &rarr;</a>
        </div>
      </div>
    </div>
  );
};

export default Support;